export default __webpack_public_path__ + "static/media/36I-117168_-37375_0.3c26603d.jpg";